import { createApp } from 'vue';
import InternshipSearchForm from '@component_path/search-contents/internship/search-form';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('internship-search-form');
  const form_values = JSON.parse(node.getAttribute('data-form-values'));
  const path = node.getAttribute('data-path');
  const props = { formValues: form_values, path: path };

  createApp(InternshipSearchForm, props).mount('#internship-search-form');
});
